import { JetView } from 'webix-jet';
import { devConfig } from '../../../config/config';

/**
 * Class representing the FilterRecargaCreditoView.
 * @extends JetView
 */
export default class FilterRecargaCreditoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with input fields for note withdrawal number and user number
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'NroNoteWithdrawal',
                    label: _('Nro Nota Retiro:'), // Label for note withdrawal number
                    labelPosition: 'top',
                    placeholder: _('Nro Nota Retiro'), // Placeholder text
                },
                {
                    view: 'text',
                    name: 'NroUser',
                    label: _('Nro Usuario:'), // Label for user number
                    labelPosition: 'top',
                    placeholder: _('Nro Usuario'), // Placeholder text
                },
            ],
        };

        // Center left section with date picker and user name input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'datepicker',
                    name: 'DateElimination',
                    label: _('Fecha Eliminación'), // Label for elimination date
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    format: webix.Date.dateToStr('%d %M %Y %h:%i %a'), // Date format
                },
                {
                    view: 'text',
                    name: 'UserName',
                    label: _('Nombre del Usuario:'), // Label for user name
                    labelPosition: 'top',
                    placeholder: _('Nombre del Usuario'), // Placeholder text
                },
            ],
        };

        // Center right section with user deleted and observations input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'UserDeleted',
                    label: _('Usuario que la Eliminó:'), // Label for user who deleted
                    labelPosition: 'top',
                    placeholder: _('Usuario que la Eliminó'), // Placeholder text
                },
                {
                    view: 'text',
                    name: 'Observations',
                    label: _('Observaciones:'), // Label for observations
                    labelPosition: 'top',
                    placeholder: _('Observaciones'), // Placeholder text
                },
            ],
        };

        // Right section with date picker for note date
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'datepicker',
                    name: 'DateNote',
                    label: _('Fecha Nota'), // Label for note date
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    format: webix.Date.dateToStr('%d %M %Y %h:%i %a'), // Date format
                },
            ],
        };

        // Upper section containing all columns
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };

        // Data object for payment values (not used in this fragment)
        const datos = {
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        // Button section with actions for clearing and consulting
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                        $$('formRecargaCredito').hide(); // Hides the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('eliminateNoteWithdraw:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            id: 'filterTableEliminateNoteWithdraw', // Form ID
            rows: [upper_section, buttons], // Form layout
            rules: {
                Email: webix.rules.isEmail, // Validation rule for email
            },
        };
    }

    /**
     * Initializes the view by hiding the filter table.
     */
    init() {
        $$('filterTableEliminateNoteWithdraw').hide(); // Hides the filter table on initialization
    }
}

// FILE DOCUMENTED
